import { styled } from '@linaria/react';
import { colors, fonts, semantic, size, space } from '../../theme/tokens';
import { EntityImage } from '../../components/EntityImage';

export const PillLabel = styled.span`
  display: inline-flex;
  flex-direction: column;
  align-items: center;

  &::after {
    content: attr(data-text);
    font-weight: ${fonts.weight.semiBold};
    height: 0;
    overflow: hidden;
    visibility: hidden;
    pointer-events: none;
  }
`;

export const JourneyPickerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (max-width: 600px) {
    width: 100%;
    width: min(300px, 100%);
    align-items: stretch;
  }
`;

export const ChevronIcon = styled.span`
  display: flex;
  align-items: center;
  color: ${semantic.text.secondary};
  transition: transform 0.15s ease;

  @media screen and (max-width: 768px) {
    color: inherit;
  }
`;

export const PillIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${semantic.text.primary};
  flex-shrink: 0;

  @media screen and (max-width: 768px) {
    color: inherit;
  }
`;

export const CategoryOption = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space['space-400']};
  width: 100%;
  padding: ${space['space-300']} ${space['space-400']};
  background: ${({ $active }) => ($active ? semantic.bg.surfaceSubtle : 'transparent')};
  border: none;
  border-radius: ${size.radius['radius-sm']};
  cursor: pointer;
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${({ $active }) => ($active ? fonts.weight.semiBold : fonts.weight.medium)};
  color: ${semantic.text.primary};
  text-align: left;
  transition: background 0.15s ease;

  &:hover {
    background: ${semantic.bg.surfaceSubtle};
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`;

export const CategoryThumb = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${space['space-1200']};
  height: ${space['space-1200']};
  border-radius: ${size.radius['radius-sm']};
  background: ${semantic.bg.surfaceSubtle};
  overflow: hidden;
`;

export const CategoryThumbImg = styled(EntityImage)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;
